import React, { Fragment } from 'react';

const VehicleAvailable = () => (
  <Fragment>
    <p>
      We offer the sleek and high-performing Tesla Model 3 in both Long
      Range (568 km) and Short Range (423 km) options. Our vehicles are
      automatically assigned for you based on fleet availability.
    </p>
    <br />
  </Fragment>
);

export default VehicleAvailable;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/General/VehicleAvailable.js